import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';

const RecordFileStatus = ({ record, open, anchorEl }) => {
  const recordedDate = record.date && moment(record.date).format('DD-MMM YYYY hh:mm');

  return (
    <React.Fragment>
      <Popper open={open} anchorEl={anchorEl} placement="left-start" style={{ zIndex: 100 }}>
        <div
          className={clsx(
            'container--recordDocumentStatus',
            'tw-bg-cfo-black tw-shadow-[3px_4px_5px_rgb(0_0_0/6%)]',
            'tw-rounded-[5px]',
            'tw-px-[15px] tw-py-[10px] tw-ml-[-15px] tw-mt-[-15px]'
          )}
        >
          <p className={clsx('tw-mb-[10px]', 'tw-text-white')}>
            Recorded on {recordedDate} by {record.recordedBy}
          </p>
          <p className={clsx('tw-m-0', 'tw-text-white tw-text-right')}>Click to undo</p>
        </div>
      </Popper>
    </React.Fragment>
  );
};

export default RecordFileStatus;
